module.exports = __webpack_public_path__ + "img/bgfw3.bdf4b05b.png";